import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class MetaDataTranslationExportButton extends Button {

	render() {
		return <Button {...this.props} title={Strings.metaManagement.translation.translationDownloadButtonLabel}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">

					<circle cx="12" cy="10" r="2" />
					<path d="M12,24L12,24c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v6C14,23.1,13.1,24,12,24z" />
					<polygon points="20,22 20,28 4,28 4,4 16,4 16,8 20,8 20,14 22,14 22,6 18,2 2,2 2,30 22,30 22,22 " />
					<polygon points="24,12 24,14 24,16 20,16 18,16 16,16 18,16 18,20 24,20 24,22 24,24 30,18 " />

				</svg>
			</i>
		</Button>;
	}
}
